module.exports = __webpack_public_path__ + "static/media/xbc.3b478177.svg";